import { useEffect, useRef, useState, useCallback } from 'react';

import { exportDataGrid } from 'devextreme/pdf_exporter';
import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    Selection,
  } from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

import { jsPDF } from 'jspdf';

import 'react-toastify/dist/ReactToastify.css';
import { persianLanguage } from '../../../../constants/persianTerms';
import { BASE_API } from '../../../../constants/api';
import { errorNotify, successNotify } from '../../../../shared/notifications';
import {onExporting} from '../../../../shared/excel-export';
import { persianDigitPrice, persianPrice } from '../../../../shared/persian-number';
import { convertPersianOrArabicNumbersToEnglishInTheString } from '../../../../shared/numbers';
import { DATAGRID_ALLOWED_FILTER_OPERATIONS, DATAGRID_ALLOWED_PAGE_SIZES, DG_FILTER_EQUALS_TO_OPERATION, DG_HEADER_FILTER_IS_APPROVED_DATA_SOURCE, DG_HEADER_FILTER_QD_UNIT_DATA_SOURCE, DG_HEADER_FILTER_TRANSACTION_ORDER_TYPE_DATA_SOURCE, DG_HEADER_FILTER_TRANSACTION_TYPE_DATA_SOURCE } from '../../../../constants/constant-arrays';
import { DEFAULT_DATAGRID_PAGE_SIZE } from '../../../../constants/constant-numbers';

import { transactionDataGridCustomStore } from '../../transaction-data-grid-custom-store';
import { calculatePersianNowDateNumber, convertPersianDateToNumber, convertPersianDateToPersianDateEnglishDigit } from '../../../../shared/date-and-time-conversion';
import SimpleDatePickerInput from '../../../report/components/simple-date-picker-input/SimpleDatePickerInput';
import { loadMessages, locale } from 'devextreme/localization';
import faMessages from 'devextreme/localization/messages/fa.json';

import { saveTransactionFieldVisibilityChange } from '../transactionUtils';
import { useAuth } from '../../../auth/auth-provider/auth-provider';
import GetTransactionFieldVisibility from '../../../api-layer/transaction-field-visibility-api/GetTransactionFieldVisibility';
import { useQuantityDefinition } from '../../../custom-providers/quantity-definition-provider/quantity-definition-provider';
import TransactionSummationData from '../transaction-summation-data/TransactionSummationData';
import { font } from '../../../../shared/pdf-font';
import PageTitle from '../../../components/page-title/PageTitle';

loadMessages(faMessages);
locale('fa-IR'); // Set to Persian (Iran)

export default function TransactionHistoryList(){
  const auth = useAuth();
  const {quantityDefinitions} = useQuantityDefinition();
  const dataGridRef = useRef(null);

  const transactionApiUrl = `${BASE_API}transactions/`;
  const filterOperations=['contains'];

  const [transactions, setTransactions] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedOrientation, setSelectedOrientation] = useState('landscape');
  
  const [allowedFilterOperation, setAllowedFilterOperation] = useState(DATAGRID_ALLOWED_FILTER_OPERATIONS);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [startUnixDate, setStartUnixDate] = useState(null);
  const [endUnixDate, setEndUnixDate] = useState(null);
  
  const [startDateThresholdActivated, setStartDateThresholdActivated] = useState(false);
  const [wrongStartDate, setWrongStartDate] = useState(false);
  const [wrongEndDate, setWrongEndDate] = useState(false);
  const [dateFilters, setDateFilters] = useState([[] , []]);
  const [transactionFieldVisibility, setTransactionFieldVisibility] = useState(null);
  const [qds, setQDS] = useState(null)
  
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [pdfDataUrl, setPdfDataUrl] = useState('');
  const pdfDocRef = useRef(null);

  const [numericBuySum, setNumericBuySum] = useState(null);
  const [numericSellSum, setNumericSellSum] = useState(null);
  const [gramBuySum, setGramBuySum] = useState(null);
  const [gramSellSum, setGramSellSum] = useState(null);
  const [numericBuyPriceSum, setNumericBuyPriceSum] = useState(null);
  const [gramBuyPriceSum, setGramBuyPriceSum] = useState(null);
  const [numericSellPriceSum, setNumericSellPriceSum] = useState(null);
  const [gramSellPriceSum, setGramSellPriceSum] = useState(null);

  const [numericReceiveSum, setNumericReceiveSum] = useState(null);
  const [numericBuyDeliverySum, setNumericBuyDeliverySum] = useState(null);
  const [gramReceiveSum, setGramReceiveSum] = useState(null);
  const [gramBuyDeliverySum, setGramBuyDeliverySum] = useState(null);
  const [gramBuyDeliveryPriceSum, setGramBuyDeliveryPriceSum] = useState(null);
  const [gramReceivePriceSum, setGramReceivePriceSum] = useState(null);
  const [numericBuyDeliveryPriceSum, setNumericBuyDeliveryPriceSum] = useState(null);
  const [numericReceivePriceSum, setNumericReceivePriceSum] = useState(null);
  
    const pdfOrientations = [
    {
      'name': 'landscape',
      'value': 'landscape',
    },
        {
      'name': 'portrait',
      'value': 'portrait',
    },
  ];
  const exportFormats = ['pdf', 'excel'];

  const changeStartDate = (unix, formatted) => {
    checkStartDateMeetThreshold(formatted);
    setStartUnixDate(unix);
    setSelectedStartDate(formatted);
    checkStartDateValidity(formatted);

    // Build the filters array
    const newFilters = [];
    if (selectedEndDate) {
      newFilters.push(['createdOn', '<', selectedEndDate]);
    }
    if (formatted) {
      newFilters.push(['createdOn', '>', formatted]);
    }

    setDateFilters(newFilters);
    getTransactions(newFilters);    
  }

  const compareStartDateWithNow = (startDate) => {
    if(startDate){
      let startDateNumber = convertPersianDateToNumber(startDate);
      let nowIs = calculatePersianNowDateNumber();
      if (startDateNumber > nowIs){
        return true;          
      }
    }
    return false;
  }

  const compareEndDateWithNow = (endDate) => {
    if(endDate){
      let endDateNumber = convertPersianDateToNumber(endDate);
      let nowIs = calculatePersianNowDateNumber();
      if (endDateNumber > nowIs){
        return true;          
      }
    }
    return false;
  }

  const compareStartDateWithEndDate = (startDate) => {
    if(selectedEndDate && startDate){
      let startDateNumber = convertPersianDateToNumber(startDate);
      let endDateNumber = convertPersianDateToNumber(selectedEndDate);
      if(startDateNumber > endDateNumber){
        return true;
      }
    }
    return false;
  }

  const compareEndDateWithStartDate = (endDate) => {
    if(endDate && selectedStartDate){
      let startDateNumber = convertPersianDateToNumber(selectedStartDate);
      let endDateNumber = convertPersianDateToNumber(endDate);
      if(startDateNumber > endDateNumber){
        return true; 
      }
    }
    return false;
  }

  const checkStartDateValidity = (startDate) => {
    const result1 = compareStartDateWithNow(startDate);
    const result2 = compareStartDateWithEndDate(startDate);
    if(result1 === true || result2 === true){
      setWrongStartDate(true);
    } else {
      setWrongStartDate(false);
    }
  }

  const checkEndDateValidity = (endDate) => {
    const result1 = compareEndDateWithNow(endDate);
    const result2 = compareEndDateWithStartDate(endDate);
    if(result1 === true || result2 === true){
      setWrongEndDate(true);
    } else {
      setWrongEndDate(false);
    }
  }

  const changeEndDate = (unix, formatted) => {
    setEndUnixDate(unix);
    setSelectedEndDate(formatted);
    checkEndDateValidity(formatted);

    const newFilters = [];
    if (formatted) {
      newFilters.push(['createdOn', '<', formatted]);
    }
    if (selectedStartDate) {
      newFilters.push(['createdOn', '>', selectedStartDate]);
    }

    setDateFilters(newFilters);

    getTransactions(newFilters);
  }

  const checkStartDateMeetThreshold = (startDate) => {
    const today = new Date()
    let thresholdDate = new Date(new Date().setDate(today.getDate() - 30)).toLocaleDateString('fa-EN');
    thresholdDate = convertPersianDateToPersianDateEnglishDigit(thresholdDate);
    const thresholdDateNumber = convertPersianDateToNumber(thresholdDate);
    const startDateNumber = convertPersianDateToNumber(startDate);
    if(startDateNumber < thresholdDateNumber){
      setStartDateThresholdActivated(true);
    } else {
      setStartDateThresholdActivated(false);
    }
  }
  
  useEffect(()=>{
      getTransactions();
      getTransactionFieldVisibility()
  }, [
    transactionFieldVisibility?.id,
  ]);
    
  const getTransactionFieldVisibility = () => {
    GetTransactionFieldVisibility(auth.user.id).then(
      response => {
        setTransactionFieldVisibility(response.data);
      }
    ).catch(
      error => {
        setTransactionFieldVisibility(null);
      }
    );
  }
    
  const getTransactions = (filters = []) => {
    const activeFilters = filters || dateFilters;
    const historyApi =`${transactionApiUrl}devextreme/histroy/`;
    const onLoadCallback = (data) => {
      setGramBuySum(data.gramBuySum);
      setGramSellSum(data.gramSellSum);
      setNumericBuySum(data.numericBuySum);
      setNumericSellSum(data.numericSellSum);
      setNumericSellPriceSum(data.numericSellPriceSum);
      setGramSellPriceSum(data.gramSellPriceSum);
      setNumericBuyPriceSum(data.numericBuyPriceSum);
      setGramBuyPriceSum(data.gramBuyPriceSum);
      setNumericReceiveSum(data.numericReceiveSum);
      setNumericBuyDeliverySum(data.numericBuyDeliverySum);
      setGramReceiveSum(data.gramReceiveSum);
      setGramBuyDeliverySum(data.gramBuyDeliverySum);
      setGramBuyDeliveryPriceSum(data.gramBuyDeliveryPriceSum);
      setGramReceivePriceSum(data.gramReceivePriceSum);
      setNumericBuyDeliveryPriceSum(data.numericBuyDeliveryPriceSum);
      setNumericReceivePriceSum(data.numericReceivePriceSum);
    };
    const res = transactionDataGridCustomStore('id', historyApi, activeFilters, onLoadCallback);
    setTransactions(res);
  };
  
  const onSelectionChanged = (selectedRowData) => 
    {
      setSelectedRowKeys(selectedRowData.selectedRowKeys); 
  };

  const persianAmount = (data) => {
    return persianPrice(data.amount);
  };

  const persianUserMarkupValue = (data) => {
    return persianPrice(data.userMarkupValue);
  };

  const persianSourceMarkupValue = (data) => {
    return persianPrice(data.sourceMarkupValue);
  };

  const persianUnitPrice = (data) => {
    return persianPrice(data.unitPrice);
  };

  const persianTotalPrice = (data) => {
    return persianDigitPrice(data.totalPrice);
  };
  
  const onRowPreparedEffect = (e) => {
    if(e.data){
      if(e.data.isApproved === 400 || e.data.isApproved === 440){
        e.rowElement.classList.add("bg-red-100");
      } else if(e.data.isApproved === 2){
        e.rowElement.classList.add("bg-green-100");
      }
    }
  }

  const onExportData = (e) => {
    e.cancel = true;
    if(e.format === 'pdf'){
        // onPdfExporting(e, selectedOrientation, true);
      onExportingPdfWithPreview(e);

    }
    if(e.format === "xlsx" || e.format === "excel"){
      onExporting(e);
    }
  }

  const saveVisibilityChange = (dataField, newValue, previousValue) => {
    const userId = auth.user.id;
    saveTransactionFieldVisibilityChange(dataField, newValue, previousValue, userId).then(
      response => {
        successNotify(persianLanguage.phrase.success.SUCCESS_200);
      }
    ).catch(
      error => {
        errorNotify(persianLanguage.phrase.error.ERROR_400);
      }
    );
  }

  const handleOptionChanged = (e) => {
    if (e.name === 'columns' && dataGridRef.current) {
      const currentColumns = e.component.option('columns');
      
      const newValue = e.value;
      const previousValue = e.previousValue;
      const columnIndex = Number(e.fullName.split('[')[1].split(']')[0]);

      const theObject = currentColumns[columnIndex]
      const dataField = theObject['dataField']; 
      saveVisibilityChange(dataField, newValue, previousValue);
     }
  };

  const fillQDS = () => {
      // Extract id and name into new array
      if(quantityDefinitions && quantityDefinitions.length > 0){
        const extractedQDS = quantityDefinitions.map(item => (
          {
            text: item.title,
            value: convertPersianOrArabicNumbersToEnglishInTheString(item.title),
        }));
        setQDS(extractedQDS);
      }  
  }

  useEffect(()=> {
    fillQDS();
  },[
    quantityDefinitions?.length,
  ])

  const indexCell = (props) => {
    return <div>{persianDigitPrice(props.rowIndex + 1)}</div>;
  };

  const onChangePDFOrientation = (e) =>{
      if(e?.itemData){
          setSelectedOrientation(e.itemData.value);
      } else {
        setSelectedOrientation('landscape');
      }
  }

  const onExportingPdfWithPreview = useCallback((e) => {
    // Stop the default export behavior
    e.cancel = true;
    
    const doc = new jsPDF({
      orientation: selectedOrientation || 'portrait',
      unit: 'pt'
    });
    
    // Your font setup
    doc.addFileToVFS("MyFont.ttf", font);
    doc.addFont("MyFont.ttf", "MyFont", "normal");
    doc.setFont("MyFont");
    
    let pdfRowIndex = 1;

    exportDataGrid({
      jsPDFDocument: doc,
      component: e.component,
      indent: 5,
      topLeft: { x: 20, y: 20 },
      margin: {
        top: 20,
        right: 10,
        bottom: 10,
        left: 10
      },
      customizeCell: ({ gridCell, pdfCell }) => {
        if (gridCell.rowType === 'header' && gridCell.column.dataField === 'rowIndex') {
          pdfCell.text = 'ردیف';
        }
        if (gridCell.rowType === 'data' && gridCell.column.dataField === 'rowIndex') {
          pdfCell.text = persianDigitPrice(pdfRowIndex);
          pdfRowIndex += 1;
        }
        pdfCell.styles = {
          halign: 'center',
          fontSize: 10
        };
      }
    }).then(() => {
      // Show preview instead of direct download
      pdfDocRef.current = doc;
      setPdfDataUrl(doc.output('datauristring'));
      setIsPreviewVisible(true);
    });
  }, []);

  const handleDownload = () => {
    if (pdfDocRef.current) {
      pdfDocRef.current.save('transaction-history.pdf');
      setIsPreviewVisible(false);
    }
  };

  return (
      <div>

        <div className="user-select-none bg-primary-main border border-2 border-primary-fourth-30p box-shadow-0-4-4-0 mb-5 mx-[28px]">
          <div className="grid grid-cols-2 m-3 " >
            <div className="grid grid-cols-1 m-3">
              <span className="mb-2">
                {`${persianLanguage.word.general.FROM} ${persianLanguage.word.general.DATE}`}
                {selectedStartDate &&
                  <span> : {selectedStartDate}</span>
                }

              </span>
              <SimpleDatePickerInput
                changeDate={changeStartDate}
                unixDate={startUnixDate}
                selectedDate={selectedStartDate}
              />
            </div>
            <div className="grid grid-cols-1 m-3 align-middle">
              <span className="mb-2">
                {`${persianLanguage.word.general.UNTIL} ${persianLanguage.word.general.DATE}`}
                {selectedEndDate &&
                  <span>: {selectedEndDate}</span>
                }
              </span>
              <SimpleDatePickerInput 
                changeDate={changeEndDate}
                unixDate={endUnixDate}
                selectedDate={selectedEndDate}
              />
            </div>
          </div>
          <div className="mx-[24px] mb-3">
            <SelectBox
              displayExpr="name"
              valueExpr="value"
              className='bg-primary-second'
              placeholder={`${persianLanguage.phrase.general.PDF_ORIENTATION_SELECTION}`}
              onItemClick={(e) => onChangePDFOrientation(e)}
              items={pdfOrientations}              
            />
          </div> 
        </div>


        <div className="user-select-none bg-primary-main border border-2 border-primary-fourth-30p box-shadow-0-4-4-0 mx-[28px]">
             <div className="border border-b-2 box-shadow-0-4-4-0 px-[26px] py-[14px] pb-5">
                {`${persianLanguage.word.general.HISTORY} ${persianLanguage.word.transaction.TRANSACTIONS}`}
              </div>

          <DataGrid
            id="grid-container"
            keyExpr="id"
            className=' user-select-none mt-[50px] mx-5 custom-datagrid-bg'
            dataSource={transactions}
            onSelectionChanged={onSelectionChanged}
            ref={dataGridRef}
            onRowPrepared={onRowPreparedEffect}
            selectedRowKeys={selectedRowKeys}
            rtlEnabled={true}
            remoteOperations={true}
            showBorders={true}
            allowColumnResizing={true}
            columnHidingEnabled={true}
            onOptionChanged={handleOptionChanged}
            onExporting={onExportData}
          >
            <Export enabled={true} formats={exportFormats} allowExportSelectedData={false} />
            <Scrolling columnRenderingMode="virtual" />
            <Selection mode="multiple"/>
            <FilterRow visible={true}  />
            <HeaderFilter visible={true} />
            <Paging defaultPageSize={DEFAULT_DATAGRID_PAGE_SIZE} /> 
            <Pager
              showPageSizeSelector={true}
              showNavigationButtons={true}
              showInfo={true}
              infoText={'صفحه {0} از {1} ({2} مورد) '}
              displayMode={'compact'}
              visible={"totalCount > 0"}
              allowedPageSizes={DATAGRID_ALLOWED_PAGE_SIZES}
            />
            <ColumnChooser 
              enabled={true}
              mode='select'
            />
            <Column
              width={50}
              visible={true}
              allowFiltering={false}
              dataField="rowIndex"
              caption={persianLanguage.word.general.INDEX}
              cellRender={indexCell}
              />
              <Column
              visible={transactionFieldVisibility?.codeVisibility}
              dataField="code"
              dataType="string"
              filterOperations={filterOperations}
              allowHeaderFiltering={false}
              allowFiltering={true}
              caption={persianLanguage.word.general.TRACKING_CODE}
              />
              {/* <Column
              width={240}
              dataField="createdOn"
              allowFiltering={false}
              allowHeaderFiltering={false}
              filterOperations={filterOperations}
              dataType="date"
              visible={transactionFieldVisibility?.createdOnVisibility}
              caption={persianLanguage.phrase.general.CREATED_ON}
              /> */}
              <Column
              dataField="transactionDate"
              dataType="string"
              allowFiltering={false}
              allowHeaderFiltering={false}
              filterOperations={filterOperations}
              visible={transactionFieldVisibility?.transactionDateVisibility}
              caption={persianLanguage.word.transaction.TRANSACTION_DATE}
              />
              <Column
              dataField="transactionWeekDay"
              dataType="string"
              allowFiltering={false}
              allowHeaderFiltering={false}
              filterOperations={filterOperations}
              visible={transactionFieldVisibility?.transactionDateVisibility}
              caption={persianLanguage.word.general.WEEKDAY}
              />
              <Column
                dataField="transactionTime"
                dataType="string"
                visible={transactionFieldVisibility?.transactionTimeVisibility}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={persianLanguage.word.transaction.TRANSATION_TIME}
              />
              <Column
              width={120}
              dataField="transactionTypeLabel"
              dataType="string"
              filterOperations={filterOperations}
              allowFiltering={true}
              allowHeaderFiltering={true}
              headerFilter={{
                  allowSearch: false, // adds a search box in the filter menu
                  dataSource: DG_HEADER_FILTER_TRANSACTION_TYPE_DATA_SOURCE,
              }}
              visible={transactionFieldVisibility?.transactionTypeLabelVisibility}
              caption={`${persianLanguage.word.transaction.TRANSACTION_TYPE}`}
              />
              <Column
              width={80}
              dataField="amount"
              visible={transactionFieldVisibility?.amountVisibility}
              allowFiltering={false}
              allowHeaderFiltering={false}
              dataType="number"
              filterOperations={DG_FILTER_EQUALS_TO_OPERATION}
              calculateCellValue={persianAmount}
              caption={persianLanguage.word.transaction.TRANSACTION_AMOUNT}
              />
              <Column
                width={50}
                dataField="quantityDefinitionUnit"
                dataType="string"
                allowFiltering={false}
                allowHeaderFiltering={true}
                headerFilter={{
                  allowSearch: false, // adds a search box in the filter menu
                  dataSource: DG_HEADER_FILTER_QD_UNIT_DATA_SOURCE,
                }}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.quantityDefinitionUnitVisibility}
                caption={persianLanguage.word.quantityDefinition.UNIT}
              />
              <Column
                width={140}
                dataField="priceQuantityDefinitionTitle"
                dataType="string"
                filterOperations={filterOperations}
                allowFiltering={true}
                allowHeaderFiltering={true}
                headerFilter={{
                  allowSearch: true, // adds a search box in the filter menu
                  dataSource: qds,
                }}
                visible={transactionFieldVisibility?.priceQuantityDefinitionTitleVisibility}
                caption={persianLanguage.word.quantityDefinition.TITLE}
              />
              <Column
              width={120}
              dataField="unitPrice"
              visible={transactionFieldVisibility?.unitPriceVisibility}
              allowFiltering={true}
              allowHeaderFiltering={false}
              filterOperations={DG_FILTER_EQUALS_TO_OPERATION}
              calculateCellValue={persianUnitPrice}
              dataType="string"
              caption={persianLanguage.word.general.UNIT_PRICE}
              />
              {/* <Column
              visible={transactionFieldVisibility?.durationTimeVisibility}
              dataField="durationTime"
              dataType="string"
              filterOperations={filterOperations}
              allowHeaderFiltering={false}
              allowFiltering={true}
              caption={persianLanguage.word.transaction.DURATION_TIME}
              /> */}
              {/* <Column
              visible={false}
              dataField="shamsiExpiration"
              filterOperations={filterOperations}
              allowFiltering={false}
              allowHeaderFiltering={false}
              dataType="string"
              caption={persianLanguage.word.transaction.EXPIRATION}
              /> */}
              <Column
              // width={150}
              dataField="totalPrice"
              allowFiltering={true}
              allowHeaderFiltering={false}
              calculateCellValue={persianTotalPrice}
              filterOperations={DG_FILTER_EQUALS_TO_OPERATION}
              dataType="number"
              visible={transactionFieldVisibility?.totalPriceVisibility}
              caption={persianLanguage.word.general.TOTAL_PRICE}
              />
              <Column
              // width={130}
              dataField="fullName"
              filterOperations={filterOperations}
              allowFiltering={true}
              allowHeaderFiltering={false}
              dataType="string"
              visible={transactionFieldVisibility?.fullNameVisibility}
              caption={persianLanguage.word.user.USER}
              />
              <Column
                dataField="createdBy"
                allowFiltering={true}
                allowHeaderFiltering={false}
                dataType="string"
                filterOperations={allowedFilterOperation}
                visible={transactionFieldVisibility?.createdByVisibility}
                caption={persianLanguage.word.user.SHOP}
              />
              <Column
                // width={80}
                dataField="orderTypeLabel"
                dataType="string"
                allowFiltering={false}
                allowHeaderFiltering={true}
                headerFilter={{
                  allowSearch: false, // adds a search box in the filter menu
                  dataSource: DG_HEADER_FILTER_TRANSACTION_ORDER_TYPE_DATA_SOURCE,
                }}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.orderTypeLabelVisibility}
                caption={`${persianLanguage.word.transaction.ORDER_TYPE}`}
              />
              <Column
              dataField="description"
              dataType="string"
              visible={transactionFieldVisibility?.descriptionVisibility}
              filterOperations={filterOperations}
              allowFiltering={false}
              allowHeaderFiltering={false}
              caption={persianLanguage.word.general.DESCRIPTIONS}
              />
                <Column
                dataField="userMarkupValue"
                dataType="string"
                calculateCellValue={persianUserMarkupValue}
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.AMOUNT} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.user.USER}`}
                />
                <Column
                dataField="userMarkupChangeTypeTitle"
                dataType="string"
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.TYPE} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.user.USER}`}
                />
                <Column
                dataField="sourceMarkupValue"
                dataType="string"
                calculateCellValue={persianSourceMarkupValue}
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.AMOUNT} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.general.SOURCE}`}
                />
                <Column
                dataField="sourceMarkupChangeTypeTitle"
                dataType="string"
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.TYPE} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.general.SOURCE}`}
                />
                <Column
                dataField="externalTransactionCode"
                dataType="string"
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
              />
              <Column
                dataField="isApprovedTitle"
                dataType="string"
                allowFiltering={true}
                allowHeaderFiltering={true}
                  headerFilter={{
                  allowSearch: false, // adds a search box in the filter menu
                  dataSource: DG_HEADER_FILTER_IS_APPROVED_DATA_SOURCE,
                }}
                filterOperations={filterOperations}
                caption={persianLanguage.word.transaction.APPROVED_OR_DISAPPROVED}
              />
              <Column
                dataField="isApprovedChangedBy"
                allowFiltering={true}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.isApprovedChangedByVisibility}
                dataType="string"
                caption={persianLanguage.word.transaction.IS_APPROVED_CHANGED_BY}
              />
          </DataGrid>              
        </div>

        <TransactionSummationData 
          numericBuyPriceSum={numericBuyPriceSum}
          gramBuyPriceSum={gramBuyPriceSum}
          numericSellPriceSum={numericSellPriceSum}
          gramSellPriceSum={gramSellPriceSum}
          numericBuySum={numericBuySum}
          numericSellSum={numericSellSum}
          gramBuySum={gramBuySum}
          gramSellSum={gramSellSum}
          numericReceiveSum={numericReceiveSum}
          numericBuyDeliverySum={numericBuyDeliverySum}
          gramReceiveSum={gramReceiveSum}
          gramBuyDeliverySum={gramBuyDeliverySum}
          gramBuyDeliveryPriceSum={gramBuyDeliveryPriceSum}
          gramReceivePriceSum={gramReceivePriceSum}
          numericBuyDeliveryPriceSum={numericBuyDeliveryPriceSum}
          numericReceivePriceSum={numericReceivePriceSum}
        />

      <Popup
        visible={isPreviewVisible}
        onHiding={() => setIsPreviewVisible(false)}
        rtlEnabled={true}
        title={`${persianLanguage.word.general.PREVIEW} ${persianLanguage.word.general.PDF}`}
        width="80%"
        height="90%"
        showTitle={true}
        dragEnabled={false}
      >
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <iframe 
            src={pdfDataUrl} 
            style={{ flexGrow: 1, width: '100%', border: 'none' }}
            title={`${persianLanguage.word.general.PREVIEW} ${persianLanguage.word.general.PDF}`}
          />
          <div style={{ marginTop: '10px', textAlign: 'center' }}>
            <Button 
              text={`${persianLanguage.word.general.DOWNLOAD} ${persianLanguage.word.general.PDF}`}
              onClick={handleDownload}
              stylingMode="contained"
              className='mx-1'
            />
            <Button 
              text={persianLanguage.word.general.CLOSE}
              onClick={() => setIsPreviewVisible(false)}
              stylingMode="outlined"
              className='mx-1'
            />
          </div>
        </div>
      </Popup>
        <div className='mb-[200px]'></div>
      </div>
    );
}